import React from 'react';

const GuapLogo = ({ size = 40, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#2E5AFF" />
        <stop offset="50%" stopColor="#8A2BE2" />
        <stop offset="100%" stopColor="#FF3B9A" />
      </linearGradient>
    </defs>
    {/* Two intersecting circles forming star shape */}
    <circle cx="35" cy="50" r="28" stroke="url(#logo-grad)" strokeWidth="2.5" fill="rgba(46,90,255,0.07)" />
    <circle cx="65" cy="50" r="28" stroke="url(#logo-grad)" strokeWidth="2.5" fill="rgba(138,43,226,0.07)" />
    {/* Intersection highlight */}
    <path
      d="M 50 22 Q 65 35 50 50 Q 35 65 50 78 Q 35 65 50 50 Q 65 35 50 22 Z"
      fill="url(#logo-grad)"
      opacity="0.5"
    />
    {/* Center star glow */}
    <circle cx="50" cy="50" r="6" fill="url(#logo-grad)" opacity="0.9" />
    {/* Four-point star */}
    <path
      d="M50 22 L53 47 L78 50 L53 53 L50 78 L47 53 L22 50 L47 47 Z"
      fill="url(#logo-grad)"
      opacity="0.85"
    />
  </svg>
);

export default GuapLogo;
